export const T = {
  en_GB: {
    answeringAs: (name: string) => `You are answering as ${name}`,
    answeringFor: (rep: string, name: string) =>
      `You are answering as ${rep}, on behalf of ${name}`,
    nothingToAnswer: "Nothing to answer here yet",
  },
  nb_NO: {
    answeringAs: (name: string) => `Du svarer som ${name}`,
    answeringFor: (rep: string, name: string) => `Du svarer som ${rep}, på vegne av ${name}`,
    nothingToAnswer: "Ingenting å svare på her ennå",
  },
} as const;
